import * as React from 'react';
import { Button, Divider, Grid, Paper, Typography, useTheme } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EmployeContracts } from '../../../interfaces/employeeDocuments.interface';
import { UserHealthPlan } from '../../../interfaces/auth.interface';
import { getDatestring } from '../../../utils/date';

interface RecordsProps {
    contracts: EmployeContracts[];
}

const DETAIL_VALUES = [
    ["Cargo", "Cargo"],
    // ["Sub-área", "Administración y Finanzas - Sistemas - Sistemas"],
    ["Empresa", "Empresa"],
    ["JornadaHorario", "Periodicidad jornada"],
    ["TipoContrato", "Tipo de contrato"],
    ["NumeroContrato", "N° Contrato"],
];
  

const buildDetails = (contract: EmployeContracts) => {
    const finalValues = [];
    for (let i = 0; i < DETAIL_VALUES.length; i++) {
        const key = DETAIL_VALUES[i][0];
        const title = DETAIL_VALUES[i][1];
        const value = contract[key as keyof EmployeContracts];
        finalValues.push([title, value || ""]);        
    }
    return finalValues;
}

const calculateTimeDiff = (fechaInicialString: string, fechaFinalString: string): { months: number; days: number } => {
    const fechaInicial: Date | null = new Date(fechaInicialString);
    const fechaFinal: Date | null = new Date(fechaFinalString);
    if (!fechaInicial || !fechaFinal) {
      throw new Error("Invalid date format. Please provide valid date strings.");
    }
    const differenceMs = Math.abs(fechaFinal.getTime() - fechaInicial.getTime());
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
    const differenceMonths = Math.floor(differenceDays / 30.437);
    return { months: differenceMonths, days: differenceDays % 30 };
  }
  

export const Record = ({contracts}: RecordsProps) => {

  return (
    <Paper
        elevation={3}
        style={{
            width: "100%", 
            borderRadius: "0.5rem",
            padding: "1.5rem",
        }}
        
    >
        <Grid container direction="row" sx={{
            padding: {sx: 0, md: "0 1rem"}
        }}>
            <Grid item style={{marginTop: ".5rem", marginBottom: "1.5rem"}}>
                <Typography variant="h6" style={{fontSize: "1rem"}}>
                    Trabajos
                </Typography>
            </Grid>
            {contracts.map((c, i) => {
                const timeDiff = i > 0 && contracts[i - 1] ? calculateTimeDiff(c.FechaInicio, contracts[i - 1].FechaInicio) : "";
                return (
                    <RecordStep 
                        date={getDatestring(c.FechaInicio, '-', false)}
                        key={`${i}`}
                        title={(i + 1) === contracts.length ? "Ingreso" : "Modificación"}
                        position={ 
                            (i + 1) === contracts.length
                                ? "start"
                                : i === 0 
                                    ? "end"
                                    : "middle"
                        }
                        duration={timeDiff 
                                ? timeDiff.months
                                    ? `${timeDiff.months} meses`
                                    : `${timeDiff.days} días`
                                : "--"}
                        details={buildDetails(c)}
                    />
                )
            })}
        </Grid>
    </Paper>
  );
}

interface RecordStepDetailsProps {
    date?: string;
    title: string;
    details?: any[] 
}

interface RecordStepProps extends RecordStepDetailsProps {
    duration?: string;
    position: "start" | "middle" | "end";
}

const Details = ({
    title, 
    details,
}: RecordStepDetailsProps) => {
    const theme = useTheme();
    const [resumenIsVisible, setResumenIsVisible] = React.useState(false);
    return (
        <Grid 
            container 
            item 
            direction="column" 
            style={{width: "26rem", marginLeft: ".5rem", flexGrow: 1}} 
            // justifyContent="center"
            textAlign="start"
        >
            <Typography variant='h6' color={theme.s10palette.S10Greygrey600} lineHeight="2rem">
                {title}
            </Typography>
            
            {/* {supervisorOne && <Grid container item sx={{flexDirection: {xs: "column", sm: "row"}}}>
                <Typography marginRight=".25rem">
                    {supervisorOne}
                </Typography>
                <Grid item sx={{display: {xs: "none", sm: "block"}}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3.33337 8.00065H12.6667M12.6667 8.00065L8.00004 3.33398M12.6667 8.00065L8.00004 12.6673" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </Grid>
                <Grid item sx={{display: {xs: "block", sm: "none"}}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99999 3.33398L7.99999 12.6673M7.99999 12.6673L12.6667 8.00065M7.99999 12.6673L3.33332 8.00065" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </Grid>
                <Typography marginLeft=".25rem">
                    {supervisorTwo}
                </Typography>
            </Grid>} */}
            {resumenIsVisible && 
                <Grid container item direction="column">
                    <table style={{width: "fit-content"}}>
                        <tbody style={{width: "auto", columnWidth: "fit-content"}}>
                            {details?.map((d, i) => (
                                <tr key={i}>
                                    <td>
                                        <Typography variant='subtitle1' lineHeight="1.5rem">
                                            {d[0]}
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography variant='subtitle1' fontWeight={700}>
                                            {d[1]}
                                        </Typography>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    
                </Grid>
            }
            {details?.length && <Grid container item style={{ width: "100%"}} justifyContent="start" marginTop=".75rem">
                <Button variant="text" onClick={() => setResumenIsVisible(!resumenIsVisible)}>
                    { resumenIsVisible
                        ? <ExpandLessIcon style={{marginRight: ".5rem"}} />
                        : <ExpandMoreIcon style={{marginRight: ".5rem"}} />
                    }
                    { resumenIsVisible
                        ? "Ocultar detalle"
                        : "Ver detalle"
                    }
                </Button>
            </Grid>}
        </Grid>
    );
}

const RecordStep = ({
    date,
    title, 
    details,
    duration,
    position,
}: RecordStepProps) => {
    const theme = useTheme();

    return (
        <Grid container item width="100%" direction="row">
            <Grid 
                container 
                item 
                direction="column" 
                style={{minHeight: "6rem", width: "2rem"}} 
                justifyContent="flex-start"
                textAlign="center"
                xs={1}
            >
                <Grid 
                    container
                    item
                    style={{
                        backgroundColor: position === "end" ? theme.s10palette.S10Blueblue600 : "white",
                        height: "2rem",
                        width: "2rem",
                        borderRadius: "50%",
                        marginRight: ".5rem",
                        border: `2px solid ${theme.s10palette.S10Blueblue600}`,
                    }}
                    justifyContent="center"
                    alignItems="center"
                >
                    {position === 'start'
                        ?   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M9 14.25V3.75M9 3.75L3.75 9M9 3.75L14.25 9" stroke="#147C9D" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        : position === 'middle'
                            ?   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M6 15.75V5.25C6 4.55252 6 4.20378 6.07667 3.91766C6.28472 3.1412 6.8912 2.53472 7.66766 2.32667C7.95378 2.25 8.30252 2.25 9 2.25C9.69748 2.25 10.0462 2.25 10.3323 2.32667C11.1088 2.53472 11.7153 3.1412 11.9233 3.91766C12 4.20378 12 4.55252 12 5.25V15.75M3.9 15.75H14.1C14.9401 15.75 15.3601 15.75 15.681 15.5865C15.9632 15.4427 16.1927 15.2132 16.3365 14.931C16.5 14.6101 16.5 14.1901 16.5 13.35V7.65C16.5 6.80992 16.5 6.38988 16.3365 6.06901C16.1927 5.78677 15.9632 5.5573 15.681 5.41349C15.3601 5.25 14.9401 5.25 14.1 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V13.35C1.5 14.1901 1.5 14.6101 1.66349 14.931C1.8073 15.2132 2.03677 15.4427 2.31901 15.5865C2.63988 15.75 3.05992 15.75 3.9 15.75Z" stroke="#1688AD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            :   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M6 15.75V5.25C6 4.55252 6 4.20378 6.07667 3.91766C6.28472 3.1412 6.8912 2.53472 7.66766 2.32667C7.95378 2.25 8.30252 2.25 9 2.25C9.69748 2.25 10.0462 2.25 10.3323 2.32667C11.1088 2.53472 11.7153 3.1412 11.9233 3.91766C12 4.20378 12 4.55252 12 5.25V15.75M3.9 15.75H14.1C14.9401 15.75 15.3601 15.75 15.681 15.5865C15.9632 15.4427 16.1927 15.2132 16.3365 14.931C16.5 14.6101 16.5 14.1901 16.5 13.35V7.65C16.5 6.80992 16.5 6.38988 16.3365 6.06901C16.1927 5.78677 15.9632 5.5573 15.681 5.41349C15.3601 5.25 14.9401 5.25 14.1 5.25H3.9C3.05992 5.25 2.63988 5.25 2.31901 5.41349C2.03677 5.5573 1.8073 5.78677 1.66349 6.06901C1.5 6.38988 1.5 6.80992 1.5 7.65V13.35C1.5 14.1901 1.5 14.6101 1.66349 14.931C1.8073 15.2132 2.03677 15.4427 2.31901 15.5865C2.63988 15.75 3.05992 15.75 3.9 15.75Z" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                    }
                </Grid>
                {(['end', 'middle'].includes(position)) && <Divider 
                    orientation="vertical" 
                    style={{flexGrow: 1, borderRightWidth: "2px", width: "1rem", margin: 0, borderColor: "#94C8D9"}} 
                    variant="middle" 
                    flexItem 
                />}
            </Grid>
            <Grid container item direction="row" xs={11}>
                <Grid container item direction="row" justifyContent="space-between">
                    <Grid 
                        container 
                        item 
                        direction="column" 
                        style={{width: "5rem", marginLeft: ".5rem"}} 
                        // justifyContent="center"
                        textAlign="center"
                        sx={{xs: 6, md: 2}}
                    >
                        <Typography 
                            variant='subtitle1' 
                            color={theme.s10palette.S10Greygrey600} 
                            marginRight=".5rem" 
                            width="5rem"
                            lineHeight="2rem"
                        >
                            {date}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        sx={{display: {xs: 'none', md: 'block'}}}
                    >
                        <Details
                            title={title}
                            details={details}
                        />
                    </Grid>
                    {duration && 
                        <Grid sx={{xs: 6, sm: 1, md: 2}} container item direction="row" alignItems="start" justifyContent="flex-end" width="10rem" height="100%">
                            <Typography>
                                {`Duración: ${duration}`}
                            </Typography>
                        </Grid>
                    }
                </Grid>
                <Grid
                    container
                    item 
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={12} 
                    sx={{display: {xs: 'block', md: 'none'}}}
                >
                    <Details
                        title={title}
                        details={details}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}
 
export const Plans = ({data}: {data: UserHealthPlan[]}) => {
    return (<Paper
        elevation={3}
        style={{
            width: "100%", 
            borderRadius: "0.5rem",
            minHeight: "10rem",
            padding: "1.5rem",
            marginTop: "1.5rem",
        }}
    >
        <Typography variant="h6" style={{fontSize: "1rem"}} marginBottom="1.5rem">
            Planes
        </Typography>
        {data.map((c: UserHealthPlan, i: number) => {
            return (
                <RecordStep 
                    key={`${i}`}
                    title={"Plan de salud"}
                    position={ 
                        (i + 1) === data.length
                            ? "start"
                            : i === 0 
                                ? "end"
                                : "middle"
                    }
                    details={[
                        ["Plan de salud", c.RegimenSalud]
                    ]}
                />
            )
        })}
    </Paper>)
}